import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getLocalStorage } from '../helpers/helper';
import {
  ILiquidacionDetalleResp,
  ILiquidacionBase64Resp,
} from '../Entities/productoVitalicio2.entities';
import { IBenefitsLinks } from '../Entities/IBenefitsLinks';

@Injectable({
  providedIn: 'root',
})
export class BffDocumentsService {
  bffUrl = `${environment.url.apiBff}`;
  private headers: HttpHeaders;
  /**
   * Constructor del servicio
   * @param http Servicio para realizar llamnadas HTTP
   */
  constructor(private http: HttpClient) {
    const token = getLocalStorage('token');
    this.headers = new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-IBM-Client-Id': environment.ClientId,
      'Access-Control-Allow-Origin': '*',
    });
    this.headers = this.headers.append(
      'Authorization',
      'Bearer ' + token.access_token
    );
  }

  /**
   * Guardar la firma de documento
   * @param rut rut del cliente
   * @param nombre nombre del cliente
   * @param email email del cliente
   */
  public saveDocumentSignature(
    rut: string,
    nombre: string,
    apellido: string,
    email: string,
    businessLines: string,
    pdfBase64: string | ArrayBuffer
  ): Observable<any> {
    const url = `${this.bffUrl}/BffSitioPrivado/DocumentSignature/${rut}`;
    const httpOptions = { headers: this.headers };
    const body = {
      clientName: nombre,
      clientLastName: apellido,
      documentoType: 'CONVENIO',
      eMail: email,
      businessLine: businessLines,
      document: pdfBase64,
    };
    const resp = this.http.post<any>(url, body, httpOptions);
    return resp;
  }

  public getLiquidacion(
    rut: string,
    nroliq: string
  ): Observable<ILiquidacionDetalleResp> {
    const url = `${this.bffUrl}/BffSitioPrivado/Settlement/${rut}/Id/${nroliq}`;
    const httpOptions = { headers: this.headers };
    const resp = this.http.get<any>(url, httpOptions);
    console.log(resp);
    return resp;
  }

  public getLiquidacionB64(
    rut: string,
    nroliq: string
  ): Observable<ILiquidacionBase64Resp> {
    const url = `${this.bffUrl}/BffSitioPrivado/Document/Settlement/${rut}/Id/${nroliq}`;
    const httpOptions = { headers: this.headers };
    const resp = this.http.get<any>(url, httpOptions);
    console.log(resp);
    return resp;
  }

  /**
   * Obtiene los link de beneficios para las polizas de BHP.
   * @param rut
   * @param policies
   * @returns Lista de polizas con sus respectivos links.
   */
  public getBenefitsLinks(
    rut: string,
    policies: string
  ): Observable<IBenefitsLinks> {
    const url = `${this.bffUrl}/BffSitioPrivado/Benefits/Links/${rut}?Policies=${policies}`;
    const httpOptions = { headers: this.headers };
    const resp = this.http.get<IBenefitsLinks>(url, httpOptions);
    console.log(resp);
    return resp;
  }
}
